import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    overflow-y: auto;

    background-color: ${theme.colors.white.Branco};

    ::-webkit-scrollbar{
        display: none;
    }
`;

export const ContainerContent = styled.div`
    width: 100%;
    max-width: 1036px;
    height: 100%;
    padding: 0 2rem 2rem 2rem;

    gap: 1.5rem;
    display: flex;
    flex-direction: column;

    @media (max-width: 479px) {
        padding: 0 1rem 1rem 1rem;
    }
`;

export const DiaryAndData = styled.div`
    width: 100%;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Option = styled.div`
    width:  auto;
    height: auto;
    padding: 0.5rem 1rem;

    cursor: pointer;

    border-radius: 5rem;
    background-color: ${props => 
        props.activeFilter === props.filterType 
            ? theme.colors.gray.Cinza_10 
            : theme.colors.gray.Cinza_12};
`;

export const Content = styled.div`
    width: 100%;
    height: 100%;

    gap: 24px;
    display: flex;

    @media (max-width: 790px) {
     flex-direction: column;
    }
`;

export const ContainerFilterChindren = styled.div`
    width: auto;
    height: auto;
    padding: 5px 5px;

    gap: 8px;
    display: flex;
    flex-direction: column;

    >div>div>input{
        padding-right: 1rem;
    }
`;

export const ContentOfSearch = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;
`;

export const Button = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1rem;
    background-color: #589BFF14;

    >img{
        width: 1.25rem;
        height: 1.25rem;
    }

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ContainerLoading = styled.div`
    width: 100%;
    height: calc(100vh - 21.05rem);

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerCards = styled.div`
    width: 100%;
    height: auto;
    padding-bottom: 2rem;

    gap: 1rem;
    display: flex;
    flex-direction: column;
`;

export const ContainerItemNotFound = styled.div`
    width: 100%;
    height: calc(100vh - 21.05rem);

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
   
   >img{
    width: 100%;
    height: auto;
    max-width: 150px;
   }
`;

export const Card = styled.div`
    width: 100%;
    height: auto;
    padding: 0.75rem;

    gap: 0.5rem;
    display: flex;
    flex-direction: column;

    border-radius: 0.5rem;
    border: 2px solid ${theme.colors.gray.Cinza_12};

    :hover{
        cursor: pointer;
    }
`;

export const CardHeader = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    justify-content: space-between;
`;

export const CropBadge = styled.div`
    width: fit-content;
    max-height: 1.5rem;
    padding: 0.25rem 0.25rem 0.25rem 0.5rem;
    
    gap: 0.25rem;
    display: flex;
    align-items: center;
    
    border-radius: 3rem;
    background-color: #21262F14;

    >p{
        white-space: nowrap;
    }
`;

export const Bullet = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  min-width: 0.75rem;
  min-height: 0.75rem;
  border-radius: 50%;
  
  background-color: ${(props) => {
    if (props.status === 1) return theme.colors.gray.Cinza_7; 
    if (props.status === 2) return theme.colors.blue.Azul_link; 
    if (props.status === 3) return theme.colors.purple.Roxo_1;
    if (props.status === 4) return theme.colors.yellow.Gema; 
    if (props.status === 5) return theme.colors.orange.Laranja_Sudeste;
    if (props.status === 6) return theme.colors.red.Vermelho_erro; 
    if (props.status === 7) return theme.colors.green.Verde_AgroReceita; 
    return theme.colors.gray.Cinza_7; 
  }};
`;

export const Description = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const BulletProfile = styled.div`
    min-width: 1.5rem;
    min-height: 1.5rem;
    max-width: 1.5rem;
    max-height: 1.5rem;
    padding: 0.1875rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 5rem;
    background-color: ${theme.colors.gray.Cinza_2};
`;

export const ContainerCultureAndLocalization = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    justify-content: space-between;
`;

export const Localization = styled.div`
    width: auto;
    height: auto;
    padding: 0.25rem 0.25rem 0.25rem 0.5rem;

    gap: 0.25rem;
    display: flex;
    align-items: center;

    border-radius: 5rem;
    background-color: ${theme.colors.gray.Cinza_12};
`;

export const BulletCulture = styled.div`
    width: auto;
    height: auto;
    padding: 0.3125rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 5rem;
    background-color: ${theme.colors.gray.Cinza_2};
`;

export const DateAndContact = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Contact = styled.div`
    width: auto;
    height: auto;

    gap: 0.25rem;
    display: flex;
    align-items: center;

    >a{
        width: 2rem;
        height: 2rem;

        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;

        >img{
            width: 1rem;
            height: 1rem;
        }
    }

    >a:nth-last-child(1){
        width: ${props => props.hasProducer ? '1rem' : '2rem'};
    }
`;

export const BulletProfileContact = styled.div`
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.1875rem;

    display: flex;
    margin-left: 0.5rem;
    align-items: center;
    justify-content: center;

    border-radius: 5rem;
    background-color: ${theme.colors.blue.Ceu};
`;

export const ContainerNewCardRight = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    margin-top: 1.5rem;
    align-items: center;
    justify-content: center;
`;

export const WrapperNewCardRight = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;


export const TextArea = styled.textarea`
    width: 100%;
    height: 8.25rem;
    padding: 0.875rem 1rem 0.875rem 1rem;

    border-radius: 0.5rem;
    border: 1px solid ${props => props.hasError ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7};

    color: ${theme.colors.gray.Cinza_2};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.bodyP};
    line-height: ${theme.typography.lineHeight.bodyP};
    letter-spacing: 0px;

    ::placeholder{
        color: ${theme.colors.gray.Cinza_7};
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.regular};
        font-size: ${theme.typography.fontSize.bodyP};
        line-height: ${theme.typography.lineHeight.bodyP};
        letter-spacing: 0px;
    }
`;

export const InputAndButton = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 0.5rem;
    display: flex;

    @media (max-width: 479px) {
        align-items: center;
        flex-direction: column;
    }
`;

export const InputButton = styled.button`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => (props.isTotvs || props.disabled) ? 'not-allowed' : 'pointer')};

    opacity: ${(props => (props.isTotvs || props.disabled) ? 0.5 : 1)};

    text-align: center;
    text-transform: uppercase;
    color:  ${(props => (props.isTotvs || props.disabled) ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link)};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extraBold};
    font-size: ${theme.typography.fontSize.tagLineM};
    line-height: ${theme.typography.lineHeight.tagLineM};
    letter-spacing: ${theme.typography.letterSpacing.normal};
`;

export const ContainerSavedEvent = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    display: flex;
    margin-top: 2rem;

    border-top: 1px solid ${theme.colors.gray.Cinza_10};
`;

export const ButtonSaved = styled.button`
    all: unset;
    width: 100%;
    height: 1.5rem;
    padding: 0.75rem 1rem;

    display: flex;
    margin-top: 1rem;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color: ${(props) => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer;
        text-align: center;
        color: ${(props) => props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.white.Branco};
    }
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;

  background-color: transparent;
  border-top: 1px solid #FFF;
  border-bottom: 1px solid #FFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const LoadingResume = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 88px;
  height: 88px;
  position: relative;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;

  background-color: transparent;
  border-top: 1px solid #FFF;
  border-bottom: 1px solid #FFF;
  border-left: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-right: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const ContainerModalAddAgronomist = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    >div >div{
        input:-webkit-autofill { 
         transition: background-color 600000s 0s !important;
        }

        >button{
            top: 55% !important;
        }
    }
`;

export const ContainerModalAddProducer = styled(ContainerModalAddAgronomist)`
    width: 420px;

    >div:nth-of-type(12){
        >div{
            >div:nth-of-type(2){
                padding-right: 4.2rem !important;
            }
        }
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const ContainerModalAddFarm = styled(ContainerModalAddAgronomist)`
    width: 420px;

    @media (max-width: 768px) {
        width: 100%;
    }
 `;

export const Assinaturas = styled.p`
  width: 100%;
  /* max-width: 400px; */
  
  text-align: center;
  font-size: 11px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const ContainerButtonsModal = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonCancelModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    border: 2px solid ${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ButtonSavedModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color:${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ContainerInputCoordinatesFarm = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    align-items: center;
`;

export const CoordinatesFarm = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: flex-start;

    >div{
        margin-bottom: 0;
    }
`;